module.exports = __webpack_public_path__ + "img/card-1.fff312fe.png";